


// import React, { useState } from "react";
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     IconButton,
//     Button,
//     Box,
//     Typography,
//     Grid,
//     Divider,
// } from "@mui/material";

// import './PostModal.css'; // Import external CSS
// // import "../../../../Components/ModalCss/BannerinputGetModal.css";

// import { MdCancel } from "react-icons/md";
// import { useSelector } from "react-redux";

// const PostJobViewModal = ({
//     open,
//     onClose,
//     setSubmittedValues,
//     submittedValues,
// }) => {
//     const [uploadedFile, setUploadedFile] = useState(null);


//     const { getJobById } = useSelector(
//         (state) => state?.getJobById
//     );

//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 // maxWidth: "600px",
//                 // margin: "auto",
//                 "& .MuiPaper-root": {
//                     borderRadius: "14px", // Target the Paper component
//                 },
//             }}
//         >
//             <Box sx={{ position: "relative" }}>
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={onClose}
//                         sx={{
//                             position: "absolute",
//                             top: 8,
//                             right: 8,
//                             color: 'white',
//                         }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">
//                         <Box>
//                             <Typography className="custom-title-text">Edit Profile</Typography>
//                         </Box>
//                     </DialogTitle>
//                 </Box>
//                 <DialogContent>
//                     {/* <Box sx={{ position: "absolute", right: "10px", top: 5 }}>
//                         <CancelSharp
//                             style={{ display: { sx: "none", md: "block" } }}
//                             // onClick={() => {
//                             //     navigate("/")
//                             // }}
//                         />
//                     </Box> */}
//                     hi2

//                 </DialogContent>

//             </Box>
//         </Dialog>
//     );
// };

// export default PostJobViewModal;

import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Grid,
    Box,
} from "@mui/material";
import { MdCancel } from "react-icons/md";
import { useSelector } from "react-redux";
import './PostModal.css';

const PostJobViewModal = ({ open, onClose }) => {
    const { getJobById } = useSelector((state) => state?.getJobById);

    const jobDetails = [
        { label: "Company Name", key: "company_name" },
        { label: "Job Title", key: "job_title" },
        { label: "Job Type", key: "job_type" },
        { label: "Location", key: "location" },
        { label: "Skills", key: "skills", isArray: true },
        { label: "Full/Part Time", key: "full_or_part_time" },
        { label: "CTC Per Annum", key: "ctc_per_annum", suffix: " LPA" },
        { label: "Experience", key: "experience" },
        { label: "Status", key: "status" },
        { label: "Educational Qualification", key: "educational_qualification" },
        { label: "Description", key: "description" },
        { label: "Contact Person", key: "contact_person" },
        { label: "Mobile No", key: "mobile_no" },
        { label: "Job URL", key: "url", isLink: true },
        { label: "Posted Date", key: "posted_date", isDate: true },
        { label: "Last Date to Apply", key: "last_date", isDate: true },
    ];

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString("en-IN", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            className="custom-dialog"
            sx={{
                "& .MuiPaper-root": {
                    borderRadius: "14px",
                },
            }}
        >
            <Box sx={{ position: "relative" }}>
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            color: 'white',
                        }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">
                        <Typography variant="subtitle1" sx={{color:"white"}}>Job Details</Typography>
                    </DialogTitle>
                </Box>

                <DialogContent dividers sx={{ overflowY: "auto", height: "400px" }}>
                    <Grid container spacing={2}>
                        {jobDetails.map((item, index) => {
                            const value = getJobById?.data?.[item.key];

                            if (!value) return null;

                            return (
                                <Grid item size={{ xs: 12, sm: 6 ,md:4}}  key={index}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                        {item.label}:
                                    </Typography>
                                    <Typography variant="body1">
                                        {item.isArray
                                            ? value.join(", ")
                                            : item.isLink
                                                ? (
                                                    <a href={value} target="_blank" rel="noopener noreferrer">
                                                        {value}
                                                    </a>
                                                )
                                                : item.isDate
                                                    ? formatDate(value)
                                                    : `${value}${item.suffix || ''}`}
                                    </Typography>
                                </Grid>
                            );
                        })}
                    </Grid>
                </DialogContent>
            </Box>
        </Dialog>
    );
};

export default PostJobViewModal;
